import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseHttpService } from "../http/base.http.service";
import { AppConfig } from 'src/app/app.config';
import { IEnvironmentConfig } from "src/app/models/environmentConfig";
import { Observable } from "rxjs";


@Injectable()
export class FeatureFlagsService extends BaseHttpService {
  constructor(private http: HttpClient, private appConfig: AppConfig) {
    super();
  }

  get envSettings(): IEnvironmentConfig {
    return this.appConfig.getEnvironmentConfig();
  }

  getFeatureFlags() {
    const url = `${this.envSettings.webApiUrl}feature-flags/client-side`;
    return this.http.get(url, {
      observe: 'body',
      responseType: 'json',
      headers: this.getHttpHeaders(),
    });
  }
  
  getFeatureFlag(flagName: string): Observable<boolean> {
    const url = `${this.envSettings.webApiUrl}feature-flag/${flagName}`;
    return this.http.get<boolean>(url, {
      observe: "body",
      responseType: "json",
      headers: this.getHttpHeaders()
    });
  }
}